import { cssTransition, toast } from 'react-toastify';

const showNotification = (text: string) => {
  toast(text, {
    transition: cssTransition({
      enter: 'toast-appear',
      exit: 'toast-hide',
    }),
  });
};

const dismissNotifications = () => toast.dismiss();

export const notificationsService = {
  showNotification,
  dismissNotifications,
};
